import React from "react";
import { useTranslation } from "react-i18next";

import { Collapse, FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { MultipleAutocompleteChip } from "@/components/forms/MultipleAutocompleteChip";
import { useCoursesQuery } from "@/learningApi";
import {
  CourseSelected,
  CourseSelectionMode,
} from "@/pages/awareness/progress/certificate_export/CertificateExportSlice";
import { CourseType } from "@/types/awareness";

type CourseSelectorProps = {
  selectionMode?: CourseSelectionMode;
  onSelectionModeChange?: (mode: CourseSelectionMode) => void;
  selectedCourses?: CourseSelected[];
  onSelectedCoursesChange?: (courses: CourseSelected[]) => void;
};

export function CourseSelector({
  selectionMode,
  onSelectionModeChange,
  selectedCourses,
  onSelectedCoursesChange,
}: CourseSelectorProps) {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useCoursesQuery();

  return (
    <RadioGroup
      onChange={(e) =>
        onSelectionModeChange(e.target.value as CourseSelectionMode)
      }
      value={selectionMode}
    >
      <FormControlLabel
        value="select"
        control={<Radio />}
        label={t("Some courses")}
      />
      <Collapse in={selectionMode === "select"} timeout="auto">
        {!isLoading && !isError && (
          <MultipleAutocompleteChip
            value={selectedCourses}
            onChange={(value) => onSelectedCoursesChange(value)}
            options={data.courses_info.map(
              (course: CourseType): CourseSelected => ({
                id: course.id,
                name: course.label_name,
              }),
            )}
          />
        )}
      </Collapse>
      <FormControlLabel
        value="all"
        control={<Radio />}
        label={t("All courses")}
      />
    </RadioGroup>
  );
}
